import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--save" icon='save'>{ children ? children : 'Save' }</Button>
}